import React from 'react';

export const ResetPasswordPageConfig = {
    settings: {
        layout: {
            config: {
                navbar: {
                    display: false
                },
                toolbar: {
                    display: false
                },
                footer: {
                    display: false
                },
                leftSidePanel: {
                    display: false
                },
                rightSidePanel: {
                    display: false
                }
            }
        }
    },
    // auth: authRoles.onlyGuest,
    routes: [
        {
            path: '/__/auth/action',
            component: React.lazy(() => import('./ResetPasswordPage'))
        }
    ]
};
